import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-screen-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="text-2xl font-bold font-heading text-accent-400 whitespace-nowrap">
                97影院
              </span>
              <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
                免费高清影视在线观看平台。蓝光超清画质，不缓冲流畅播放，
                海量电影电视剧一网打尽，极致视觉享受尽在97影院。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h4>
              <div className="flex flex-col gap-2">
                {navLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">内容分类</h4>
              <div className="flex flex-col gap-2">
                <span className="text-sm text-foreground-400">科幻电影</span>
                <span className="text-sm text-foreground-400">悬疑烧脑</span>
                <span className="text-sm text-foreground-400">国产剧集</span>
                <span className="text-sm text-foreground-400">动漫番剧</span>
                <span className="text-sm text-foreground-400">韩剧热播</span>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">合作伙伴</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                更多合作伙伴信息即将公布，敬请期待。
              </p>
              <div className="flex gap-3 mt-4">
                <span className="w-8 h-8 flex items-center justify-center text-foreground-500 cursor-pointer hover:text-accent-400 transition-colors">
                  <i className="ri-wechat-fill text-lg"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center text-foreground-500 cursor-pointer hover:text-accent-400 transition-colors">
                  <i className="ri-weibo-fill text-lg"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center text-foreground-500 cursor-pointer hover:text-accent-400 transition-colors">
                  <i className="ri-bilibili-fill text-lg"></i>
                </span>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2025 97影院. 本站内容仅供学习交流，请支持正版影视作品。
            </p>
            <p className="text-xs text-foreground-500">
              蓝光超清画质 · 不缓冲流畅播放 · 免费在线观看
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}